import { render, staticRenderFns } from "./Page14.vue?vue&type=template&id=2f240da1&scoped=true&"
import script from "./Page14.vue?vue&type=script&lang=ts&"
export * from "./Page14.vue?vue&type=script&lang=ts&"
import style0 from "./Page14.vue?vue&type=style&index=0&id=2f240da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f240da1",
  null
  
)

export default component.exports